export interface SafeTemplateArgument {
  readonly value: string;
  readonly safe: boolean;
}

export type TemplateArgument = SafeTemplateArgument | string | number;

function html(s: readonly string[], ...args: readonly TemplateArgument[]): string {
  let builder = "";
  for (let i = 0; i < s.length; i++) {
    builder += s[i];
    let arg = args[i] ?? "";

    if (!isSafe(arg)) {
      arg = html.escape(String(arg));
    }
    builder += arg.value;
  }

  return builder;
}

html.safe = function (s: string | SafeTemplateArgument): SafeTemplateArgument {
  if (isSafe(s)) {
    return s;
  }

  return {
    value: s,
    safe: true,
  };
};

html.escape = function (s: string): SafeTemplateArgument {
  if (isSafe(s)) {
    return s;
  }

  return html.safe(
    s
      .replaceAll("&", "&amp;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&apos;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;"),
  );
};

function isSafe(s: TemplateArgument): s is SafeTemplateArgument {
  return typeof s === "object" && "safe" in s && typeof s.safe === "boolean" && s.safe;
}

export { html };
